import { z } from 'zod';

export const verificationAttributeItem = z.object({
  handle: z.string(),
  name: z.string(),
});

export const verificationSectionSchema = z.object({
  verificationAttributes: z.array(verificationAttributeItem),
});

export const externalIdentityVerificationSchema = z
  .object({
    inAll: verificationSectionSchema,
    inAny: verificationSectionSchema,
    notInAll: verificationSectionSchema,
  })
  .optional();
